const DRAG_AND_DROP_MESSAGE_TYPE = Object.freeze({
  ERROR_NOT_ALLOWED_FOLDER: 'errorNotAllowedFolder',
  ERROR_DROP_IN_SELECTED_FOLDER: 'errorDropInSelectedFolder',
  MOVABLE: 'movable',
})

export { DRAG_AND_DROP_MESSAGE_TYPE }
